module.exports = "/assets/data/24623a3286d325ffb29ce0a0381f07de-KA29.data.json";